export default __webpack_public_path__ + "static/media/PAFI_KI Go Private 2025.ad29f0be.pdf";